<template>
  <div class="become-moderator-container">
    <a-row class="become-moderator">
      <a-col :span="24">
        <a-spin :spinning="isLoading" size="large">
          <div class="spin-content">
            <a-card :title="cardTitle" class="style3">
              <div>
                <ModeratorDeclined v-if="status == 'declined'" key="declined" />
                <ModeratorUnderReview v-if="status == 'review'" key="review" />
                <ModeratorSubmit v-if="status == null || status === 'invited'" @onSubmit="status = $event" key="submit" />
              </div>
            </a-card>
          </div>
        </a-spin>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import store from '@/store';
import ModeratorDeclined from './moderatorDeclined';
import ModeratorUnderReview from './moderatorUnderReview';
import ModeratorSubmit from './moderatorSubmit';

export default {
  components: {
    ModeratorDeclined,
    ModeratorUnderReview,
    ModeratorSubmit,
  },
  data: () => ({
    isLoading: false,
    cardTitle: 'Become a Moderator!',
    status: null,
  }),
  methods: {
    async doInitData() {
      const { moderator } = store.state.user.user;
      this.status = moderator && moderator.status;
    },
  },
  async mounted() {
    await this.doInitData();
  },
};
</script>
<style lang="scss">
.become-moderator-container.content-page {
  .become-moderator {
    padding: 20px;
    text-align: center;

    .ant-btn {
      height: auto;
      white-space: initial;
      padding: 6px;
      min-width: 80px;
    }

    .ant-spin-spinning {
      max-height: initial;
    }
  }
}
</style>
